module.exports = __webpack_public_path__ + "img/fore.59ea4a3e.png";